import type { Router } from '@remix-run/router';
import type { TimelyPageView } from 'types/routing';
import { isElectronEnv } from 'utils/electron';
import timelyAnalytics from '../tracking/timely-analytics';

export function handleEnterRoute(pageView: TimelyPageView) {
  const { title, path, ...rest } = pageView;
  const platform = !isElectronEnv() ? 'Web' : 'Desktop';

  // Register page view via Segment Analytics wrapper (same API)
  timelyAnalytics.page(platform, title, {
    title,
    platform,
    ...rest,
  });

  return true;
}

export const TITLE_TEMPLATE = '%s - Timely';

export const createHistoryAdapter = (router: Pick<Router, 'navigate'>) => {
  return {
    push: (to: string) => {
      router.navigate(to, { replace: false });
    },
    replace: (to: string) => {
      router.navigate(to, { replace: true });
    },
  };
};

export type HistoryAdapter = ReturnType<typeof createHistoryAdapter>;

export const defaultUsersView = (hasPeopleDashboardFeature: boolean) => {
  return hasPeopleDashboardFeature ? 'dashboard' : 'list';
};

const joinPaths = (paths: Array<string>): string => paths.join('/').replace(/\/\/+/g, '/');

/**
 * Helper to create URLs with the correct account ID basename (i.e. /settings -> /4301/settings).
 */
export const createHref = (pathname: string, basename: string) => {
  if (!pathname) {
    return basename;
  }

  let joinedPathname = pathname;
  if (basename !== '/') {
    joinedPathname = pathname === '/' ? basename : joinPaths([basename, pathname]);
  }

  return joinedPathname;
};
